import { render } from "./CardTariff.vue?vue&type=template&id=106a5f56&scoped=true"
import script from "./CardTariff.vue?vue&type=script&lang=js"
export * from "./CardTariff.vue?vue&type=script&lang=js"

import "./CardTariff.vue?vue&type=style&index=0&id=106a5f56&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106a5f56"]])

export default __exports__